import axiosIns from '@/libs/axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getInfinaAccounts() {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('getInfinaAccounts')
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    getCurrencies() {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('getCurrencies')
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    getInfinaReportData(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('getInfinaReportData', queryParams)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    downloadInfinaReportXlsx(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('downloadInfinaReportXlsx', queryParams, { responseType: 'blob' })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
